import { Form } from '@anytag/shared-atoms';
import { ToggleOption } from '@anytag/shared-types';
import { PartnerFormSchema } from './schema';
import { Template } from './Template';
import { PartnerFormProps, PartnerFormValues } from './types';

export const PartnerForm = ({ onSubmit, defaultValues }: PartnerFormProps) => (
  <Form.Provider<PartnerFormValues>
    onSubmit={onSubmit}
    values={{
      id: defaultValues?.id,
      logo: defaultValues?.logo,
      countryId: defaultValues?.countryId || '',
      agencyIds: defaultValues?.agencyIds || [],
      companyUrl: defaultValues?.companyUrl || '',
      netsuiteId: defaultValues?.netsuiteId || '',
      phoneNumber: defaultValues?.phoneNumber || '',
      advertiserIds: defaultValues?.advertiserIds || [],
      partnerAgencyName: defaultValues?.partnerAgencyName || '',
      privateInfluencerIds: defaultValues?.privateInfluencerIds || [],
      influencerCostPermission: defaultValues?.influencerCostPermission || ToggleOption.TRUE
    }}
    zodSchema={PartnerFormSchema}
  >
    <Template />
  </Form.Provider>
);

export * from './types';
